<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Dashboard
          </h1>
        </div>
      </div>
    </div>

    <!-- grid wrapper card -->
    <div
      class="wrapper-card grid lg:grid-cols-2 grid-cols-1 md:grid-cols-2 gap-2 mt-5"
    >
      <!-- card  -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-orange-100 rounded-full w-14 h-14 text-lg p-3 text-orange-600 mx-auto"
          >
          <span class="">
            <img
              src="@/assets/img/plant.png"
              alt="icon"
              width="30"
              height="30"
            />
          </span>
          </div>
        </div>
        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ dataAllPlants.length }}
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Plant Total</h2>
        </div>
      </div>
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-green-200 rounded-full w-14 h-14 text-lg p-3 text-red-600 mx-auto"
          >
          <span class="">
            <img
              src="@/assets/img/group.png"
              alt="icon"
              width="30"
              height="30"
            />
          </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ dataGroups.length }}
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">
            Total Group
          </h2>
        </div>
      </div>
    </div>


    <!-- end wrapper card -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";

  export default {
    name: "Dashboard",
    data() {
      return {
      };
      // end chart data line
    },
    components: {
      Icon,
    },
    methods: {
      ...mapActions(useCounterStore,['getAllPlanst', 'getDataGroup']),
    },
    created(){
      this.getAllPlanst()
      this.getDataGroup()
    },
    computed: {
      ...mapState(useCounterStore, ['dataAllPlants', 'dataGroups' ]),
    },
    mounted() {}
  };
</script>
